// extracted by mini-css-extract-plugin
export const sectionSpacing = "pdf-display-module--section-spacing--1c8o0";
export const rowSpacing = "pdf-display-module--row-spacing--E61JO";
export const rowSpacingSml = "pdf-display-module--row-spacing-sml--2uf7Y";
export const docDisplay = "pdf-display-module--docDisplay--3VmOC";
export const pageNums = "pdf-display-module--pageNums--1fOLy";
export const bottomButtons = "pdf-display-module--bottomButtons--vQFRu";
export const overlayButtons = "pdf-display-module--overlayButtons--2VXtR";
export const tallButtons = "pdf-display-module--tallButtons--3AbNo";
export const wideButtons = "pdf-display-module--wideButtons--24RVC";
export const tall = "pdf-display-module--tall--2fTS2";
export const wide = "pdf-display-module--wide--nQvKG";